<template>
	<c-dialog ref="dialog" height="400" width="600" @resolve="editHandle">
		<c-form ref="form" unit-width="100%">
      <c-input type="hidden" name="id"></c-input>
      <c-form-item label="类目" required tip="不同类目的质检项不同，不支持修改模板关联类目">
        <c-select name="category_id" async @search="searchCategory" :value-data="selectedCategory" disabled></c-select>
      </c-form-item>
      <c-form-item label="模板名称" required tip="模板名称不允许重复">
				<c-input name="template_name" v-model="new_template_name" maxlength="20"></c-input>
			</c-form-item>
      <c-form-item label="标签">
				<c-input name="label" maxlength="20"></c-input>
			</c-form-item>
      <c-form-item label="通用模板">
        <c-radio-group name="general_purpose_flag" :options="enableDic"></c-radio-group>
      </c-form-item>
			<c-form-item label="备注">
        <c-input type="textarea" name="remark"></c-input>
			</c-form-item>
    </c-form>
	</c-dialog>
</template>

<script>
import {mapState} from 'vuex'
export default {

  computed: {
    // 获取dictName选项数据
    ...mapState(['enableDic'])
  },

	data() {
		return {
        new_template_name:'',
        selectedCategory:[] //已选中的类目
		}
	},

	methods: {
    /*******搜索类目*****************/
    searchCategory(keyword, resolve){
      this.request({
        url:'/spu/category/options',
        data: {
          keyword: keyword
        },
        success:data => {
          resolve(data);
        }
      })
    },
		/*********打开编辑框，初始化**********/
		open(data) {
			this.$refs.form.clear();
			if (data) {
          //已选中的[类目]
          this.selectedCategory.push({
              name: data.category_name,
              value:data.category_id
          });
          this.new_template_name = data.template_name+'_副本';
				  this.$refs.form.set(data);
			}else {
          this.$refs.form.set({"general_purpose_flag": 1});
      }
			//填充form表单
			this.$refs.dialog.open({
				  title: '复制模板【'+data.template_name+'】'
			});
		},
		/*******添加、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: '/spu/template/copy',
				rule: {
          category_id: '请选择模板关联的类目',
          template_name: '请输入模板名称'
				},
				dataFormatter: data => {
					return data;
				},
				success: (data, res) => {
					next();
          this.$message({
            message: '复制模板成功',  // 提示内容,
            type: 'success'
          });
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>